/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import trillionOrangeUrl from '../../../assets/gems/trillion_orange.svg?inline';
export function TrillionOrange({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: trillionOrangeUrl,
        alt: "TrillionOrangeImage"
    });
}
